import React from 'react'

const ConvertTime = ({ timeOrder }) => {
    if (!timeOrder) {
        return
    }

    function tConvert(time) {
        const match = time.match(/^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/);

        if (!match) return time;

        let hours = parseInt(match[1], 10);
        const minutes = match[2];
        const seconds = match[3];
        const ampm = hours < 12 ? 'AM' : 'PM';

        hours = hours % 12 || 12;

        return `${hours}:${minutes}${seconds ? `:${seconds}` : ''} ${ampm}`;
    }

    let convertTime = tConvert(timeOrder)

    return (
        <span>
            {convertTime}
        </span>
    )
}

export default ConvertTime
